<template>
  <header
    :class="{
      'bd-banner-navbar': isBannerEnabled,
      'bd-navbar-border-repairify': isRepairifyUkOnly,
      'bd-navbar-border-mahle': isMahle(),
      'bd-navbar-border-default': !isRepairifyUkOnly && !isMahle(),
      'bd-navbar-border-clever': isClever()
    }"
    class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar"
  >
    <div class="row custom-row">
      <div class="col-sm">
        <a
          :class="{ 'custom-menu': !isClever(), 'custom-menu-clever': isClever() }"
          @click="toggleNav"
        ><font-awesome-icon icon="bars" style="padding-left: 15px; padding-top:10px;" /></a>

        <a class="navbar-brand mr-0 mr-md-2 custom-logo-link" aria-label="diagnostics" @click="goHome">
          <img :src="logo" alt="diagnostics" style="height: 48px" />
        </a>

        <div class="navbar-nav-scroll">
          <ul class="navbar-nav bd-navbar-nav flex-row">
            <li v-for="n in nav" :key="n.name" class="nav-item">
              <router-link
                v-if="isAllowed(n.url)"
                exact
                class="nav-link"
                :to="n.url"
                :title="n.name"
              >
                {{ n.name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm">
        <!-- <h2 v-if="appName && typeof appName === 'string'" class="custom-title">{{ t(appName) }}</h2> -->
        <h2 class="custom-title">{{ t(appName()) }}</h2>
        <div v-if="isMahle()" class="custom-list">
          <ul>
            <li>
              {{ t('mahle.label.credit') + ':' }}
              <span :class="creditClass">{{ mahleCoinBalance }}</span>
            </li>
            <li>
              {{ t('mahle.label.diagnosticlicense') + ':' }}
              <span :class="licenseClass">{{ mahleDiagnosticLicenseStatus }}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="col-sm">
        <div class="custom-user">
          <ul class="navbar-nav flex-row ml-md-auto d-none d-md-flex">
            <li v-if="userName" class="nav-item">
              <a
                id="userProfile"
                href="#"
                :class="{ 'nav-link': !isClever(), 'nav-link-clever': isClever(), 'custom-link': true }"
                title="userProfile"
                @click="goUserProfile"
              >
                <font-awesome-icon icon="user" class="pr-1" />
                {{ userName }}
              </a>
            </li>
            <li class="nav-item">
              <a
                id="logout"
                href="#"
                :class="{ 'nav-link': !isClever(), 'nav-link-clever': isClever(), 'custom-link': true }"
                title="logout"
                @click="logout"
              >
                <font-awesome-icon icon="sign-out-alt" />
                {{ t('logout.label.title') }}
              </a>
            </li>
          </ul>
          <div class="custom-name"><span>{{ lastName }}</span></div>
        </div>
      </div>
    </div>
    <audio
      id="chatNotifier"
      src="https://dxstmhyqfqr1o.cloudfront.net/sound/SendBird-default.mp3"
      class="custom-audio"
    ></audio>
  </header>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { appId, appName, logoPath, isUK, isMahle, isRepairify, isClever } from '@/plugins/globals.js'
import { forceLogout } from '@/helpers/auth'

const { t } = useI18n()
const store = useStore()

const nav = ref([])
const toggleBar = ref(false)

// Getters
const userProfile = computed(() => store.getters['auth/userProfile'])
const chatAs = computed(() => store.getters['auth/chatAs'])
const userInfo = computed(() => store.getters['auth/userInfo'])
const isAllowed = store.getters['auth/isAllowed']
const mahleCoinBalance = computed(() => store.getters['auth/mahleCoinBalance'])
const mahleDiagnosticLicenseStatus = computed(() => store.getters['auth/mahleDiagnosticLicenseStatus'])

// Computed values
const isRepairifyUkOnly = computed(() => isUK() && isRepairify())
const isBannerEnabled = computed(() => (window.config ? window.config.environment !== 'prod' : false))
const userName = computed(() => userProfile?.value?.userName?.trim() || '')
const lastName = computed(() => {
  const c = chatAs?.value
  if (c?.lastName && String(c.lastName).trim()) return String(c.lastName).trim()
  if (userInfo?.value?.lastName && String(userInfo.value.lastName).trim()) {
    return String(userInfo.value.lastName).trim()
  }
  return userProfile?.value?.lastName?.trim() || ''
})
const logo = computed(() => (appId() === 5 ? '/static/protech.svg' : logoPath()))

const creditClass = computed(() => (mahleCoinBalance.value <= 0 || mahleCoinBalance.value === '?' ? 'red-text' : 'green-text'))
const licenseClass = computed(() => (['Expired', '?'].includes(mahleDiagnosticLicenseStatus.value) ? 'red-text' : 'green-text'))
const emit = defineEmits(['toggleBar'])

// Methods
const logout = () => {
  console.log(`DEBUG => [nav-top] => logout .. ${true}`)
  // store.dispatch('auth/clearToken')
  forceLogout()
  toggleBar.value = false
  window.location.assign('/')
}

const toggleNav = () => {
  toggleBar.value = !toggleBar.value
  emitToggle()
}
const closeMenu = () => {
  toggleBar.value = false
  emitToggle()
}
const goHome = () => {
  toggleBar.value = false
  emitToggle()
  window.location.assign('/')
}

const goUserProfile = () => {
  toggleBar.value = false
  emitToggle()
  if (!isMahle()) {
    window.location.assign('/user/')
  }
}

const emitToggle = () => {
  emit('toggleBar', toggleBar.value)
}
defineExpose({
  closeMenu
})
</script>

<style scoped lang="scss">
.custom-logo-link {
  cursor: pointer;
}

.custom-audio {
  display: none;
}

.custom-row {
  width: 100%;
}
.custom-menu {
  margin-right: 15px;
  font-size: 1.5em;
  font-weight: 600;
  cursor: pointer;
}
.custom-menu:hover {
  color: blue;
}
.custom-menu-clever {
  margin-right: 15px;
  font-size: 1.5em;
  font-weight: 600;
  cursor: pointer;
}
.custom-menu-clever:hover {
  color: #EAAA00;
}

.custom-title {
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}

.custom-link {
  cursor: pointer;
}

.custom-user {
  float: right;
}

.custom-name {
  text-align: center;
  font-size: 0.8em;
  margin: 0 auto;
  padding: 0;
  width: 100%;
}

.custom-list {
  display: flex;
  justify-content: center;
  width: 100%;

  ul {
    display: flex;
    padding: 0;
    margin: 0 -10px;
    list-style: none;
  }

  li {
    margin: 0 10px;
  }
}

.red-text {
  color: #FF0000;
}

.green-text {
  color: #66CC66;
}
</style>
